import styled from 'styled-components'

import { Font14 } from 'components/Typography'

export const ClaimHomeMessage = styled.div`
  ${Font14};
  padding: 0 24px;
  text-align: left;
`

export const ClaimHomeFormContent = styled.div`
  max-width: 320px;
  margin: 0 auto;
  margin-top: 16px;
`
